import React, { useState, useEffect, useRef } from 'react';
import { Bell, Menu, LogOut } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { es } from 'date-fns/locale';

const DashboardHeader = ({ userProfile, unreadCount, notifications, setMobileMenuOpen, handleNotificationClick, onLogout, markAsRead }) => {
    const [notifOpen, setNotifOpen] = useState(false);
    const notificationRef = useRef(null);

    // Cierra el dropdown si se hace clic fuera
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (notificationRef.current && !notificationRef.current.contains(event.target)) {
                setNotifOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [notifOpen]);

    const handleItemClick = (notification) => {
        // Llama a la función del padre para navegar
        handleNotificationClick(notification); 
        // Cierra el dropdown
        setNotifOpen(false);
    };

    const fallbackUnread = Array.isArray(notifications)
        ? notifications.reduce((total, notif) => total + (!notif.read ? 1 : 0), 0)
        : 0;
    const effectiveUnread = Math.max(unreadCount || 0, fallbackUnread);
    const displayUnread = effectiveUnread > 99 ? '99+' : effectiveUnread;

    return (
        <header className="header">
            <button className="hamburger-btn" onClick={() => setMobileMenuOpen(true)}><Menu size={24} /></button>
            <div className="welcome-message">
                <span><span className="welcome-text-prefix">Bienvenido, </span><strong>{userProfile?.fullName || userProfile?.email}</strong></span>
                                            {userProfile?.isFoundingPartner && (
                                                <span style={{
                                                    background: '#f59e0b',
                                                    color: '#fff',
                                                    borderRadius: '12px',
                                                    fontSize: '0.7rem',
                                                    fontWeight: 700,
                                                    padding: '2px 10px',
                                                    marginLeft: '8px',
                                                    letterSpacing: '0.04em',
                                                    textTransform: 'uppercase',
                                                    boxShadow: '0 1px 4px rgba(245,158,11,0.10)'
                                                }}>
                                                    SOCIO FUNDADOR
                                                </span>
                                            )}
            </div>
            <div className="header-actions">
                <div ref={notificationRef} className="notification-icon-wrapper">
                    <button
                        className={`header-notif-icon ${effectiveUnread > 0 ? 'has-unread' : ''}`}
                        onClick={() => setNotifOpen(v => !v)}
                        aria-label={effectiveUnread > 0 ? `Tienes ${effectiveUnread} notificaciones sin leer` : 'Notificaciones'}
                        aria-live="polite"
                    >
                        <Bell size={20} />
                        {effectiveUnread > 0 && <span className="header-notif-badge">{displayUnread}</span>}
                    </button>

                    {/* El desplegable va FUERA del botón: un <button> no puede contener otro
                        <button> (HTML inválido) — el navegador lo "corregía" reordenando el DOM,
                        y por eso el panel se veía cortado/fuera de lugar en vez de desplegarse
                        prolijo debajo de la campana. */}
                    {notifOpen && (
                        <div className="header-notif-dropdown">
                            <div className="header-notif-title">Notificaciones</div>
                            <div className="header-notif-list">
                                {notifications.length === 0 ? (
                                    <div className="header-notif-empty">No tienes notificaciones.</div>
                                ) : (
                                    notifications.slice(0, 5).map(n => (
                                        <div key={n.id} className={`header-notif-item ${!n.read ? 'unread' : ''}`} onClick={() => handleItemClick(n)}>
                                            <p>{n.message}</p>
                                            <small>{n.createdAt?.toDate() ? formatDistanceToNow(n.createdAt.toDate(), { addSuffix: true, locale: es }) : ''}</small>
                                        </div>
                                    ))
                                )}
                            </div>
                            <div className="header-notif-footer">
                                <button onClick={() => handleItemClick({ link: 'notificaciones' })}>Ver todas</button>
                            </div>
                        </div>
                    )}
                </div>
                <button onClick={onLogout} className="sign-out-button" title="Cerrar Sesión"><LogOut size={20} /></button>
            </div>
        </header>
    );
};

export default DashboardHeader;